module.exports = __webpack_public_path__ + "assets/img/yyCare_d_p1.a7b73a7d.png";